(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["klaviyo-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klaviyo-signup')) {
    customElements.define(
      'klaviyo-signup',
      class KlaviyoSignup extends HTMLElement {
        connectedCallback() {
          this.channel = 'email';
          this.form = this.querySelector('form');
          this.emailInput = this.querySelector('input[name="email"]');
          this.phoneInput = this.querySelector('input[name="phone"]');
          this.submitButton = this.querySelector('button[type="submit"]');
          this.message = this.querySelector('.klaviyo-signup__message');
          this.pills = this.querySelectorAll('.klaviyo-signup__pill');

          this.pills.forEach((pill) => {
            pill.addEventListener('click', () => this.setChannel(pill.dataset.channel));
          });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }

        setChannel(channel) {
          this.channel = channel;
          const isEmail = channel === 'email';
          this.emailInput.hidden = !isEmail;
          this.phoneInput.hidden = isEmail;
          this.pills.forEach((pill) => {
            const active = pill.dataset.channel === channel;
            pill.classList.toggle('klaviyo-signup__pill--active', active);
            pill.setAttribute('aria-pressed', String(active));
          });
          this.hideMessage();
        }

        normalizePhone(value) {
          let digits = value.replace(/[^\d+]/g, '');
          if (digits.startsWith('+')) return digits;
          if (digits.startsWith('00')) return `+${digits.slice(2)}`;
          return `${this.dataset.countryCode || '+1'}${digits.replace(/^0+/, '')}`;
        }

        showMessage(text, isError) {
          this.message.textContent = text;
          this.message.classList.toggle('klaviyo-signup__message--error', Boolean(isError));
          this.message.hidden = false;
        }

        hideMessage() {
          this.message.hidden = true;
        }

        async onSubmit(event) {
          event.preventDefault();
          const isEmail = this.channel === 'email';
          const input = isEmail ? this.emailInput : this.phoneInput;
          const value = input.value.trim();
          const errorText = this.dataset.errorText || 'Something went wrong. Please try again.';

          const phoneNumber = isEmail ? '' : this.normalizePhone(value);
          const phoneIsValid = /^\+[1-9]\d{7,14}$/.test(phoneNumber);

          if (!value || (isEmail ? !input.checkValidity() : !phoneIsValid)) {
            this.showMessage(errorText, true);
            input.focus();
            return;
          }

          const companyId = this.dataset.companyId;
          const listId = isEmail ? this.dataset.emailList : this.dataset.smsList;
          if (!companyId || !listId) {
            this.showMessage(errorText, true);
            return;
          }

          const attributes = isEmail
            ? {
                email: value,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              }
            : {
                phone_number: phoneNumber,
                subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
              };
          const payload = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Footer signup',
                profile: { data: { type: 'profile', attributes } },
              },
              relationships: { list: { data: { type: 'list', id: listId } } },
            },
          };

          this.submitButton.disabled = true;
          this.hideMessage();

          try {
            const response = await fetch(
              `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
                body: JSON.stringify(payload),
              }
            );

            if (response.ok) {
              this.showMessage(this.dataset.successText || 'Thanks for subscribing!', false);
              this.form.reset();
            } else {
              let detail = '';
              try {
                const body = await response.json();
                detail = body?.errors?.[0]?.detail || '';
              } catch (parseError) {
                detail = '';
              }
              this.showMessage(detail || errorText, true);
            }
          } catch (networkError) {
            this.showMessage(errorText, true);
          } finally {
            this.submitButton.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
